// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3CYyE","footer":"Form_footer__1ecke"};